<template lang="pug">
.font-shadow
  // desktop size
  .desktop(:style="{ textAlign, paddingLeft, paddingTop, paddingRight, paddingBottom }")
    h2.desktop(v-html="textContent", :style="{ color, fontSize }")
    .shadow.desktop(v-html="textContent", :style="{ textAlign: shadowAlign, top, left, right, bottom, color: shadowColor, fontSize: shadowSize, lineHeight: lineHeight }")

  // mobile size
  .mobile(:style="{ textAlign: mobileTextAlign, paddingLeft: mobilePaddingLeft, paddingTop: mobilePaddingTop, paddingRight: mobilePaddingRight, paddingBottom: mobilePaddingBottom }")
    h2.mobile(v-html="textContent", :style="{ color, fontSize: mobileFontSize }")
    .shadow.mobile(v-html="textContent", :style="{ textAlign: mobileShadowAlign, top: mobileTop, left: mobileLeft, right: mobileRight, bottom: mobileBottom, color: shadowColor, fontSize: mobileShadowSize, lineHeight: mobileLineHeight }")

</template>

<script>
export default {
  props: [
    'textContent',
    'top',
    'left',
    'right',
    'bottom',
    'textAlign',
    'color',
    'shadowColor',
    'shadowSize',
    'shadowAlign',
    'paddingLeft',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'fontSize',
    'lineHeight',
    'mobileTop',
    'mobileLeft',
    'mobileRight',
    'mobileBottom',
    'mobileTextAlign',
    'mobileShadowSize',
    'mobileShadowAlign',
    'mobilePaddingLeft',
    'mobilePaddingTop',
    'mobilePaddingRight',
    'mobilePaddingBottom',
    'mobileFontSize',
    'mobileLineHeight'
  ]
}
</script>

<style lang="sass">
@import "../sass/_variables.sass"

.font-shadow
  position: relative
  +mobile
    text-align: left !important
  h2
    font-size: 50px
    font-style: italic
    font-weight: 900
    margin-bottom: 14px
    position: relative
    z-index: 1
    +mobile
      font-size: 35px
      margin-bottom: 0
  .shadow
    position: absolute
    top: 0
    font-size: 80px
    font-weight: 900
    font-style: italic
    width: 100vw
    +mobile
      line-height: 94.5%
      width: 640px
</style>
